import { render, staticRenderFns } from "./FormYoutubeLink.vue?vue&type=template&id=7d033beb&scoped=true"
import script from "./FormYoutubeLink.vue?vue&type=script&lang=js"
export * from "./FormYoutubeLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d033beb",
  null
  
)

export default component.exports